module.exports = __webpack_public_path__ + "img/name-approval-1997.5a715718.jpg";